module.exports = __webpack_public_path__ + "image/Sure_Grip.png";